import { HazardLookup, RiskAssessmentMatrix, RiskLookup, TakeFiveDashboardQueryModel, TaskTakeFiveModel, Location } from "shared/models/api/models";
import appSettings from "shared/settings/appSettings";
import { getToken } from "../../overrides/api";
import { httpGet, httpPost, http_fetch } from "./httpService";

const railOperationFromsUriPath = new URL('/api/rail-operations-forms', appSettings.api.portalApi);
const hazardLookupPath = `${railOperationFromsUriPath}/hazard`;
const hazardRiskLookupPath = `${railOperationFromsUriPath}/hazard-risk`;
const riskAssessmentMatrixPath = `${railOperationFromsUriPath}/risk-assessment-matrix`;
const submittedTakeFivesPath = `${railOperationFromsUriPath}/submitted`;
const takeFiveDetails = `${railOperationFromsUriPath}/details`;
const takeFiveLocationsPath = `${ railOperationFromsUriPath }`;
function appendFormData(formData: FormData, data: any, parentKey = '') {
    if (data === null || data === undefined) return;

    if (Array.isArray(data)) {
        data.forEach((value, index) => {
            const key: string | undefined = parentKey ? `${parentKey}[${index}].` : index.toString();
            appendFormData(formData, value, key);
        });
    } else if (typeof data === 'object' && !(data instanceof File) && !(data instanceof Blob)) {
        Object.keys(data).forEach(key => {
            const value = data[key];
            const fullKey = parentKey ? `${parentKey}${key}` : key;
            appendFormData(formData, value, fullKey);
        });
    } else {
        // Convert non-string values to string unless it's a File/Blob
        formData.append(parentKey, data instanceof File || data instanceof Blob ? data : String(data));
    }
}

export const addTaskTakeFive = async (taskTakeFive: TaskTakeFiveModel) => {
    const formData = new FormData();
    appendFormData(formData, taskTakeFive);

    const response = await fetch(railOperationFromsUriPath.toString(), {
        method: 'POST',
        body: formData,
        headers: await getAuthHeader(),
    });
    return response;
}

export async function getAuthHeader() {
    const token = await getToken();

    return {
        Authorization: `Bearer ${token}`
    }
}

export const getHazards = async (): Promise<HazardLookup[]> => {
    return await httpGet<HazardLookup[]>(`${hazardLookupPath.toString()}`);
}

export const getRisks = async (): Promise<RiskLookup[]> => {
    return await httpGet<RiskLookup[]>(`${hazardRiskLookupPath.toString()}`);
}

export const getRiskAssessmentMatrix = async (): Promise<RiskAssessmentMatrix[]> => {
    return await httpGet<RiskAssessmentMatrix[]>(`${riskAssessmentMatrixPath.toString()}`);
}

export const getSubmittedTakeFives = async (form: TakeFiveDashboardQueryModel): Promise<TaskTakeFiveModel[]> => {
    const results = await httpPost<TaskTakeFiveModel[]>(submittedTakeFivesPath.toString(), form)
        .catch(e => {
            console.error(e);
            return [] as TaskTakeFiveModel[];
        });
    return results;
}

export const getTakeFiveDetails = async (id: number) => {
    return await httpGet<TaskTakeFiveModel>(`${takeFiveDetails}/${id}`)
        .catch(e => { console.log(e); return {} as TaskTakeFiveModel });
};

export const getImageFile = async (docId: number) => {
    const imageResponse = await http_fetch(`${railOperationFromsUriPath}/${docId}`, 'GET')
        .catch(e => {
            console.error(e);
            return {} as Response;
        });
    return imageResponse;
}

export const getLocations = async (): Promise<Location[]> => {
    return await httpGet<Location[]>(`${ takeFiveLocationsPath.toString() }`);
}